export default __webpack_public_path__ + "static/media/@marimassariol.85f17945.jpg";